// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"193":"4352b355","269":"82f11df0"}[chunkId] + ".chunk.css";
};